import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { queriesPayees } from "@query";
import { WSQueries } from "../../../../query/WSQuery";
import { ResourceHistory } from "../../../../shared/components/ResourceHistory";
import { usePayeeHistoryResources } from "../../hooks/usePayeeHistoryResources";
import { selectorCounterpartyDisplayName } from "../../../../shared/selectors/selectorCounterpartyDisplayName";
import { useXWingspanPayerId } from "./useXWingspanPayerId";
import { PAYEES_ROOT_PATH, useGoToPayeeDetails } from "../../utils";

export const RoutePayeeHistory: React.FC<
  RouteComponentProps<{ payeeId: string }>
> = ({
  match: {
    params: { payeeId }
  },
  history
}) => {
  const xWingspanAccount = useXWingspanPayerId();
  // Direct `getPayee`, not the `searchPayeeRows` projection. The search index is
  // currently unstable, and this screen gates its whole render on the read, so a
  // failing index took the page down with it. The trade is the displayed name:
  // the row carries the server-resolved `profile.resolvedName`, the entity does
  // not, so `selectorCounterpartyDisplayName` falls back through
  // displayName -> company DBA -> email -> id.
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId,
    xWingspanAccount
  });
  const goToPayeeDetails = useGoToPayeeDetails();
  const historyResources = usePayeeHistoryResources(payeeId);

  return (
    <WSPage>
      <WSQueries queries={{ queryPayee }}>
        {({ queryPayeeData }) => (
          <>
            <WSPageToolbar
              title="Contractor history"
              breadcrumbs={[
                {
                  label: "Contractors",
                  onClick: () => {
                    history.push(PAYEES_ROOT_PATH);
                  }
                },
                {
                  label: selectorCounterpartyDisplayName(queryPayeeData),
                  onClick: () => {
                    goToPayeeDetails(payeeId);
                  }
                },
                {
                  label: "Contractor history"
                }
              ]}
            />

            <WSGrid>
              <WSGrid.Item span={{ l: "8" }}>
                <WSList gap="2XL">
                  <ResourceHistory
                    resources={historyResources}
                    xWingspanAccount={xWingspanAccount}
                  />
                </WSList>
              </WSGrid.Item>
            </WSGrid>
          </>
        )}
      </WSQueries>
    </WSPage>
  );
};
